import React from 'react';
import {AddToPrint, PrintDirectly} from '../containers';

const PrintButtons = (props) => {
  let {ids, label, disabled, style, className} = props;
  // TODO printdirectly is broken
  return (
    <span style={style} className={className}>
      {/*&nbsp;<PrintDirectly ids={ids} disabled={disabled}/>*/}
      &nbsp;&nbsp;<AddToPrint ids={ids} label={label} disabled={disabled}/>
    </span>
  );
};

PrintButtons.propTypes = {
  ids: React.PropTypes.array.isRequired,
  label: React.PropTypes.string.isRequired,
  disabled: React.PropTypes.bool,
  style: React.PropTypes.object,
  className: React.PropTypes.string
};

PrintButtons.defaultProps = {
  disabled: false,
  label: '__not loaded yet__',
  style: {},
  className: ''
};

export default PrintButtons;



/** WEBPACK FOOTER **
 ** ./src/modules/print/components/PrintButtons.js
 **/